import { render, staticRenderFns } from "./ClusterPieChart.vue?vue&type=template&id=0049f7fe"
import script from "./ClusterPieChart.vue?vue&type=script&lang=js"
export * from "./ClusterPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports